<template>
  <iframe
    :src="downloadPath"
    frameborder="0"
    hidden
  />
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      //
    }
  },
  computed: {
    ...mapState('core', ['downloadPath'])
  }
}
</script>
